import { setTerm } from './helpers';

export const setBlackFriday = setTerm('is_black_friday');
